import PropTypes from 'prop-types';
import { augmentClassName } from '../../../utils/GlobalCssProxy';
import DropdownBasic from '../dropdown-basic';

const className = augmentClassName();

const DropdownUnderline = ({ items, label, onChange, selectedItem }) => {
  const handleChange = ({ selectedItem: item }) => {
    onChange(item);
  };

  return (
    <DropdownBasic
      items={items}
      onChange={handleChange}
      selectedItem={selectedItem}
      {...className('dropdown', 'mt-n4')}
    >
      <DropdownBasic.Label {...className('sr-only')}>
        {label}
      </DropdownBasic.Label>
      <DropdownBasic.Trigger
        variant="dropdown-trigger"
        {...className('dropdown_toggle', 'font-weight-bold', 'font-family-sans-serif')}
      >
        <span {...className('button-label', 'ml-n3', 'pb-1')}>
          {selectedItem.label}
        </span>
      </DropdownBasic.Trigger>
      <DropdownBasic.Item>{item => item.label}</DropdownBasic.Item>
    </DropdownBasic>
  );
};

DropdownUnderline.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string
    })
  ),
  label: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  selectedItem: PropTypes.shape({
    label: PropTypes.string
  })
};

export default DropdownUnderline;
